import { makeAutoObservable, reaction, runInAction } from 'mobx'
import { WidgetStore } from 'page/catalog/store/WidgetStore'
import { OutfitsPreviewResponse } from 'type/outfits'
import { fetchJson } from 'util/fetch'

export class OutfitsPreviewStore {
  outfits: (string | null)[] = []
  private readonly dispose: () => void
  private request = 0

  constructor(widget: WidgetStore) {
    makeAutoObservable(this)
    this.dispose = reaction(
      () => [widget.user_id, widget.outfits, widget.last_time] as const,
      ([user_id]) => void this.load(user_id),
    )
  }

  destroy() {
    this.dispose()
  }

  private async load(user_id: string) {
    const request = ++this.request
    if (!user_id) {
      this.outfits = []
      return
    }
    try {
      const params = new URLSearchParams({ user_id })
      const data: OutfitsPreviewResponse = await fetchJson(`/api/outfits/preview?${params}`)
      runInAction(() => {
        if (request === this.request) this.outfits = data.outfits
      })
    } catch (e) {
      console.error('outfits preview failed', e)
    }
  }
}
